import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Dataflow01 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_application")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("application", context.tenant.modules);

    return {
      title: () => context.t("Workflow", { ns: "application.shared" }),
      crumb: [
        {
          Icon: Dataflow01,
        },
        {
          label: context.t("Workflow", { ns: "application.shared" }),
          link: { to: "/application/applications" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
